<template>
  <div>
    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <!-- Field: Full Name -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Name"
            label-for="full-name"
          >
            <b-form-input
              id="full-name"
              v-model="user.name_surname"
              :disabled="isFenomen"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Username -->
        <b-col
          cols="12"
          md="3"
          v-if="type=='influencer'"
        >
          <b-form-group
            label="Username"
            label-for="username"
          >
            <b-form-input
              id="username"
              :disabled="isFenomen"
              v-model="user.username"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Email"
            label-for="email"
          >
            <b-input-group>
              <b-form-input
                id="email"
                v-model="user.email"
                type="email"
                disabled="disabled"
                :placeholder="!user.email || user.email_status === 'no_email' ? 'Email yok' : ''"
              />
              <b-input-group-append v-if="!isFenomen && type == 'influencer' ">
                <b-button
                  variant="outline-primary"
                  @click="openChangeEmailModal"
                  v-b-tooltip.hover
                  title="Email Adresini Değiştir"
                >
                  <feather-icon icon="EditIcon" size="16" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <small v-if="!user.email || user.email_status === 'no_email'" class="text-muted">
              Bu kullanıcının email adresi bulunmuyor
            </small>
          </b-form-group>
        </b-col>

        <!-- Field: Phone -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Telefon"
            label-for="telefon"
          >
            <b-input-group
              label="Email"
              label-for="email"
            >
              <b-input-group-prepend is-text>
                (+90)
              </b-input-group-prepend>
              <cleave
                id="phone"
                v-model="user.phone"
                class="form-control"
                :raw="false"
              :disabled="isFenomen"
                :options="clevePhone"
                placeholder="507 091 19 69"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Influencer Specific Fields -->
      <b-row v-if="type === 'influencer'">
        <b-col cols="12">
          <hr>
          <h6 class="text-primary mb-3">Ödeme Ayarları</h6>
        </b-col>

        <!-- Field: Link İçi Ödeme Oranı -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Link İçi Ödeme Oranı (%)"
            label-for="link-ici-odeme-orani"
          >
            <b-form-input
              id="link-ici-odeme-orani"
              v-model.number="user.link_ici_odeme_orani"
              type="number"
              step="0.01"
              :disabled="isFenomen"
              min="0"
              max="100"
              placeholder="0.00"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Link Dışı Ödeme Oranı -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Link Dışı Ödeme Oranı (%)"
            label-for="link-disi-odeme-orani"
          >
            <b-form-input
              id="link-disi-odeme-orani"
              v-model.number="user.link_disi_odeme_orani"
              type="number"
              step="0.01"
              :disabled="isFenomen"
              min="0"
              max="100"
              placeholder="0.00"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Payment Amount -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Ödeme Tutarı (₺)"
            label-for="payment-amount"
          >
            <b-form-input
              id="payment-amount"
              v-model.number="user.payment_amount"
              type="number"
              :disabled="isFenomen"
              step="0.01"
              min="0"
              placeholder="0.00"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Vesting Period -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Vesting Süresi (Gün)"
            label-for="vesting-period"
          >
            <b-form-input
              id="vesting-period"
              v-model.number="user.vesting_period"
              type="number"
              :disabled="isFenomen"
              min="1"
              max="365"
              placeholder="14"
            />
            <small class="text-muted">Varsayılan: 14 gün</small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="type=='influencer'">
        <!-- birth date -->
        <b-col md="4">
          <b-form-group
            label-for="use_system_date"
            label="Sistem izleme tarihi"
          >
            <flat-pickr
              v-model="user.use_system_date"
              class="form-control"
              name="date"
              :disabled="user.verify==false || isFenomen"
              placeholder="Sistem izleme tarihi"
            />
          </b-form-group>
          <div v-if="user.verify==false">
            
          <b-alert variant="danger" class="p-1" show>
            Henüz kayıt tamamlanmamış bu nedenle sistem izleme tarihi belirlenmemiştir.
          </b-alert>
          </div>
        </b-col>
        <!--/ birth date -->
        <b-col md="4">
          <b-form-group class="mb-2"
            label-for="is_maintenance"
            label="BAKIM MODU AÇIK/KAPALI">
              <b-form-checkbox v-model="user.is_maintenance" switch>
              </b-form-checkbox>
            </b-form-group>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BAlert, BSpinner, BInputGroup, BInputGroupAppend, BInputGroupPrepend, BBadge, VBTooltip
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import Swal from 'sweetalert2'
import flatPickr from 'vue-flatpickr-component'
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import axiosIns from '@/axios'

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BAlert,
    BSpinner,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BBadge,
    Cleave,
    flatPickr
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit, root }) {

    const clevePhone = {
      blocks: [3, 3, 2, 2],
      numericOnly: true,
    }

    const customerInfo = store.state.user.customerInfo

    // Email değiştirme modalını aç
    const openChangeEmailModal = async () => {
      const { value: newEmail } = await Swal.fire({
        title: 'Email Adresini Değiştir',
        html: `
          <div class="text-left">
            <p class="mb-2"><strong>Mevcut Email:</strong> ${props.user.email || 'Yok'}</p>
            <label for="new-email" class="form-label">Yeni Email Adresi:</label>
          </div>
        `,
        input: 'email',
        inputPlaceholder: 'yeni@email.com',
        inputAttributes: {
          id: 'new-email',
          autocapitalize: 'off',
          autocorrect: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Devam Et',
        cancelButtonText: 'İptal',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        inputValidator: (value) => {
          if (!value) {
            return 'Email adresi girmelisiniz!'
          }
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          if (!emailRegex.test(value)) {
            return 'Geçerli bir email adresi giriniz!'
          }
          if (value === props.user.email) {
            return 'Yeni email mevcut email ile aynı olamaz!'
          }
        }
      })

      if (newEmail) {
        confirmEmailChange(newEmail)
      }
    }

    // Email değişikliğini onayla
    const confirmEmailChange = (newEmail) => {
      Swal.fire({
        title: 'Emin misiniz?',
        html: `
          <div class="text-left">
            <p><strong>Eski Email:</strong> ${props.user.email || 'Yok'}</p>
            <p><strong>Yeni Email:</strong> ${newEmail}</p>
            <hr>
            <p class="text-warning">
              <small>
                <i class="feather icon-alert-triangle"></i>
                Bu işlem geri alınamaz. Email değişikliği geçmişe kaydedilecektir.
              </small>
            </p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Değiştir',
        cancelButtonText: 'İptal',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          changeEmail(newEmail)
        }
      })
    }

    // Email değiştirme API isteği
    const changeEmail = (newEmail) => {
      const loadingSwal = Swal.fire({
        title: 'İşleniyor...',
        text: 'Email adresi değiştiriliyor',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      axiosIns.post('/auth/change-email', {
        user_id: props.user.id,
        old_email: props.user.email,
        new_email: newEmail,
        user_type: props.type,
        customer_id:customerInfo.id,
      })
        .then(response => {
          Swal.close()
          
          if (response.data.success) {
            // User objesini güncelle
            emit('email-changed')
            Swal.fire({
              icon: 'success',
              title: 'Başarılı!',
              text: response.data.message || 'Email adresi başarıyla değiştirildi.',
              confirmButtonText: 'Tamam',
              customClass: {
                confirmButton: 'btn btn-success',
              },
              buttonsStyling: false,
            })
          } else {
            if (response.data.id) {
              Swal.fire({
                  icon: 'error',
                  title: 'Kayıt Hatası!',
                  text: response.data.message || 'Bu e-posta adresi zaten kayıtlı.',
                  showCancelButton: true,
                  confirmButtonText: 'İlgili Fenomeni Gör', 
                  cancelButtonText: 'Vazgeç', 
                  
                  customClass: {
                      confirmButton: 'btn btn-primary mr-1',
                      cancelButton: 'btn btn-outline-secondary',
                  },
                  buttonsStyling: false,
              }).then((result) => {
                  if (result.isConfirmed) {
                      window.location.href = `/influencer/${response.data.id}`;
                  }
              });
          } else {
              // ID gelmediğinde (Genel Hata)
              Swal.fire({
                  icon: 'error',
                  title: 'Hata!',
                  text: response.data.message || 'Email değiştirme işlemi başarısız.',
                  confirmButtonText: 'Tamam',
                  customClass: {
                      confirmButton: 'btn btn-danger',
                  },
                  buttonsStyling: false,
              });
          }
          }
        })
        .catch(error => {
          Swal.close()
          
          Swal.fire({
            icon: 'error',
            title: 'Hata!',
            text: error.response?.data?.error || 'Bir hata oluştu. Lütfen tekrar deneyin.',
            confirmButtonText: 'Tamam',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })
        })
    }

    return {
      clevePhone,
      openChangeEmailModal
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-heading {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

::v-deep .swal2-html-container {
  text-align: left !important;
}
</style>